import { IGame, IGamesStore } from '../store';

import api, { request } from '../../../../api';
import { IErrorsStore } from '../../../errors/store';
import { IStore } from '../../../index';

export const updateGame = async (
  state: IStore,
  gameId: number,
  data: any,
  playerSignature?: Blob
): Promise<{ games?: IGamesStore; errors?: IErrorsStore }> => {
  if (true || playerSignature) {
    delete data.signature;
  }

  const response = await request.patch(`${api.games}${gameId}`, data);

  if (response.error) {
    return { errors: { games: { msg: 'Error updating the game.' } } };
  }

  const updatedGame: IGame = response;

  return {
    games: {
      ...state.games,
      [updatedGame.id]: updatedGame
    }
  };
};
